import './index.css';
import React from 'react';

interface IProps {
  imageUrl: string;
  containerStyle?: Record<string, any>;
  imageStyle?: {
    width: number;
    height: number;
    borderRadius?: number;
  };
  placeholder?: string;
  onLoadSuccess?: () => void;
}

export class MapMarkerImage extends React.Component<IProps, any> {
  render() {
    const {
      imageUrl, imageStyle, placeholder, containerStyle, onLoadSuccess,
    } = this.props;
    const width = imageStyle?.width || 40;
    const height = imageStyle?.height || 40;
    const borderRadius = imageStyle?.borderRadius || 8;

    return (
      <view className="container" style={containerStyle}>
        <view
          className="image-shadow"
          style={{
            width,
            height,
            borderRadius
          }}
        >
          <view
            className="image-radius"
            style={{ borderRadius }}
          >
            <image
              className="image"
              src={imageUrl}
              resizeMode="aspectFill"
              placeholder={placeholder}
              onLoadSuccess={onLoadSuccess}
            />
          </view>
        </view>
        <image className="arrow" src="assets://map/marker_bottom_arrow.png" />
      </view>
    );
  }
}
